import * as components from './components';

import * as actions from './actions';
import reducer from './reducer';
import * as epics from './epics';
import * as selectors from './selectors';
import * as types from './types';
import * as utils from './utils';
import * as constants from './constants';

export default {
    constants,
    components,
    actions,
    reducer,
    epics,
    selectors,
    utils,
};

export { types as Promo };
